const config = {
  apiUrl: "https://rndapi.ajinpaper.co.kr/PP",
  // apiUrl: "https://jv.ajinpaper.app/PP",
  // apiUrl: "http://192.168.7.33:4321/PP",
  otherKey: "some_value",
};

export default config;